// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"950a5420","160":"9f6e41be","208":"abd0aaaa","293":"dc8668cc","453":"419a5d54","516":"016bea8a","519":"e90159dc","917":"0f55c9cd","946":"a96fb618"}[chunkId] + ".chunk.js";
};